import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { NavLink } from "react-router-dom";

import useStyles from "./style";
import Open from "./Open";
import Close from "./Close";

const Navbar = () => {
  const classes = useStyles();
  return (
    <>
      <Grid container className={classes.navbar}>
        <h2 style={{ fontWeight: "400" }}>
          <NavLink to="/" style={{ textDecoration: "none", color: "#547972" }}>
            WordSearch
          </NavLink>
        </h2>
        <Close />
        <Open />
      </Grid>
    </>
  );
};

export default Navbar;
